import { debounceJukeboxRequestAction } from 'sharedActions/sharedActions';
import { mapDispatchNextPageWithRedirect } from 'reg_redesign/redux/connectFunctions';
import { merge } from 'lodash';
import BasicInput from '@opploans/basic-input-component/BasicInput';
import configureProgressBar from 'reg_redesign/config/configureProgressBar';
import configureTitle from 'reg_redesign/config/configureTitle';
import DateMask from 'components/rebrand/DateMask';
import nextButtonConfig from 'reg_redesign/config/nextButtonConfig';
import SocialSecurity from 'components/component_lib/SocialSecurity';
import SocialSecurityNumberMask from 'components/rebrand/SocialSecurityNumberMask';

const page4 = {
  defaultNextPage: 'page-5',
  content: [
    configureProgressBar(12),
    configureTitle('Let’s verify your identity.'),
    {
      component: BasicInput,
      name: 'dateOfBirth',
      props: {
        id: 'dateOfBirth',
        label: 'Date of Birth (MM/DD/YYYY)',
        isNumeric: true,
        InputProps: {
          inputComponent: DateMask
        },
        formControlStyle: {
          marginBottom: '1.5rem'
        }
      }
    },
    {
      component: SocialSecurity,
      name: 'socialSecurityNumber',
      props: {
        id: 'socialSecurityNumber',
        label: 'Social Security Number',
        InputProps: {
          inputComponent: SocialSecurityNumberMask
        },
        formControlStyle: {
          marginBottom: '1.5rem'
        },
        onChange: debounceJukeboxRequestAction
      }
    },
    {
      component: SocialSecurity,
      name: 'confirmSocialSecurityNumber',
      props: {
        id: 'confirmSocialSecurityNumber',
        label: 'Confirm Social Security Number',
        InputProps: {
          inputComponent: SocialSecurityNumberMask
        }
      }
    },
    merge({}, nextButtonConfig('page-4'), {
      dispatchOverride: mapDispatchNextPageWithRedirect
    })
  ]
};

export default page4;
